<template>
</template>

<script>
import { store } from '../store'

export default {
  name: 'Home',
  components: {
  },
  mounted () {
    if (this.store.user.state.isLoggedIn) {
      this.$router.push({ name: 'dashboard-overview' })
    } else {
      this.$router.push({ name: 'login' })
    }
  },
  computed: {
    store () {
      return store
    }
  }
}
</script>
